/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_Min_WidthInputs */

const en_tables_rule_sets_min_width = /** @type {(inputs: Tables_Rule_Sets_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Min Width`)
};

const de_tables_rule_sets_min_width = /** @type {(inputs: Tables_Rule_Sets_Min_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Breite`)
};

/**
* | output |
* | --- |
* | "Sets Min Width" |
*
* @param {Tables_Rule_Sets_Min_WidthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_min_width = /** @type {((inputs?: Tables_Rule_Sets_Min_WidthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_Min_WidthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_min_width(inputs)
	return de_tables_rule_sets_min_width(inputs)
});